module.exports = __webpack_public_path__ + "static/media/facebook.4d3d820d.svg";